import { OWebApp } from "oweb";
import { SXUrl } from "@/gobl.bundle";
import ServiceStore from "./default";

export default class UrlsStore extends ServiceStore<SXUrl> {
	constructor(app: OWebApp) {
		super(app, SXUrl, "urls");
	}
}
